import { render, staticRenderFns } from "./IlluBilanPersonnalise.vue?vue&type=template&id=5b254706&"
import script from "./IlluBilanPersonnalise.vue?vue&type=script&lang=js&"
export * from "./IlluBilanPersonnalise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports